var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgGallery = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 125,
    height: 62,
    viewBox: "0 0 125 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 117,
    height: 52,
    rx: 26,
    fill: "#0078A8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 117,
    height: 52,
    rx: 26,
    stroke: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.9432 28.0795H59.0909C58.733 25.7955 56.7557 24.2045 54.1818 24.2045C51.1364 24.2045 48.8523 26.4432 48.8523 30.1932C48.8523 33.875 51.0341 36.1591 54.2443 36.1591C57.125 36.1591 59.1875 34.3068 59.1875 31.3068V29.9091H54.4659V31.5568H57.1477C57.1136 33.2159 56.0057 34.267 54.2557 34.267C52.3068 34.267 50.9716 32.8068 50.9716 30.1705C50.9716 27.5511 52.3295 26.0966 54.2102 26.0966C55.6136 26.0966 56.5682 26.8466 56.9432 28.0795ZM63.3263 36.1761C64.6956 36.1761 65.5138 35.5341 65.8888 34.8011H65.957V36H67.9343V30.1591C67.9343 27.8523 66.0536 27.1591 64.3888 27.1591C62.5536 27.1591 61.1445 27.9773 60.6899 29.5682L62.6104 29.8409C62.8149 29.2443 63.3945 28.733 64.4002 28.733C65.3547 28.733 65.8774 29.2216 65.8774 30.0795V30.1136C65.8774 30.7045 65.2581 30.733 63.7184 30.8977C62.0252 31.0795 60.4059 31.5852 60.4059 33.5511C60.4059 35.267 61.6615 36.1761 63.3263 36.1761ZM63.8604 34.6648C63.0024 34.6648 62.3888 34.2727 62.3888 33.517C62.3888 32.7273 63.0763 32.3977 63.9968 32.267C64.5365 32.1932 65.6161 32.0568 65.8831 31.8409V32.8693C65.8831 33.8409 65.099 34.6648 63.8604 34.6648ZM71.7393 24.3636H69.6824V36H71.7393V24.3636ZM75.5911 24.3636H73.5343V36H75.5911V24.3636ZM81.2498 36.1705C83.2839 36.1705 84.6816 35.1761 85.0453 33.6591L83.1248 33.4432C82.8464 34.1818 82.1646 34.5682 81.2782 34.5682C79.9487 34.5682 79.068 33.6932 79.051 32.1989H85.1305V31.5682C85.1305 28.5057 83.2896 27.1591 81.1419 27.1591C78.6419 27.1591 77.0112 28.9943 77.0112 31.6875C77.0112 34.4261 78.6191 36.1705 81.2498 36.1705ZM79.0566 30.8125C79.1191 29.6989 79.943 28.7614 81.1703 28.7614C82.3521 28.7614 83.1476 29.625 83.1589 30.8125H79.0566ZM86.5506 36H88.6074V30.8693C88.6074 29.7614 89.4426 28.9773 90.5733 28.9773C90.9199 28.9773 91.3517 29.0398 91.5278 29.0966V27.2045C91.3403 27.1705 91.0165 27.1477 90.7892 27.1477C89.7892 27.1477 88.954 27.7159 88.6358 28.7273H88.5449V27.2727H86.5506V36ZM94.1184 39.2727C95.7206 39.2727 96.6468 38.4489 97.1411 37.0568L100.647 27.2841L98.4479 27.2727L96.4309 33.8636H96.3399L94.3286 27.2727H92.1468L95.3115 36.1818L95.1354 36.6534C94.7547 37.6477 94.1524 37.7159 93.2547 37.4545L92.7774 39.0568C93.0559 39.1705 93.5559 39.2727 94.1184 39.2727Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.1818 23.4545C25.7802 23.4545 25.4545 23.7802 25.4545 24.1818V27.0909C25.4545 27.4926 25.7802 27.8182 26.1818 27.8182H28.8182C29.2198 27.8182 29.5455 27.4926 29.5455 27.0909V24.1818C29.5455 23.7802 29.2198 23.4545 28.8182 23.4545H26.1818ZM26.1818 22H28.8182C30.0232 22 31 22.9768 31 24.1818V27.0909C31 28.2959 30.0232 29.2727 28.8182 29.2727H26.1818C24.9768 29.2727 24 28.2959 24 27.0909V24.1818C24 22.9768 24.9768 22 26.1818 22ZM26.1818 30.7273H28.8182C30.0232 30.7273 31 31.7041 31 32.9091V35.8182C31 37.0232 30.0232 38 28.8182 38H26.1818C24.9768 38 24 37.0232 24 35.8182V32.9091C24 31.7041 24.9768 30.7273 26.1818 30.7273ZM26.1818 32.1818C25.7802 32.1818 25.4545 32.5074 25.4545 32.9091V35.8182C25.4545 36.2198 25.7802 36.5455 26.1818 36.5455H28.8182C29.2198 36.5455 29.5455 36.2198 29.5455 35.8182V32.9091C29.5455 32.5074 29.2198 32.1818 28.8182 32.1818H26.1818Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1818 23.4545C34.7802 23.4545 34.4545 23.7802 34.4545 24.1818V27.0909C34.4545 27.4926 34.7802 27.8182 35.1818 27.8182H37.8182C38.2198 27.8182 38.5455 27.4926 38.5455 27.0909V24.1818C38.5455 23.7802 38.2198 23.4545 37.8182 23.4545H35.1818ZM35.1818 22H37.8182C39.0232 22 40 22.9768 40 24.1818V27.0909C40 28.2959 39.0232 29.2727 37.8182 29.2727H35.1818C33.9768 29.2727 33 28.2959 33 27.0909V24.1818C33 22.9768 33.9768 22 35.1818 22ZM35.1818 30.7273H37.8182C39.0232 30.7273 40 31.7041 40 32.9091V35.8182C40 37.0232 39.0232 38 37.8182 38H35.1818C33.9768 38 33 37.0232 33 35.8182V32.9091C33 31.7041 33.9768 30.7273 35.1818 30.7273ZM35.1818 32.1818C34.7802 32.1818 34.4545 32.5074 34.4545 32.9091V35.8182C34.4545 36.2198 34.7802 36.5455 35.1818 36.5455H37.8182C38.2198 36.5455 38.5455 36.2198 38.5455 35.8182V32.9091C38.5455 32.5074 38.2198 32.1818 37.8182 32.1818H35.1818Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd",
    x: 0,
    y: 0,
    width: 125,
    height: 62,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow",
    result: "effect2_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow",
    result: "shape"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgGallery);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/gallery.041fdb9f46ff163a64dba887280da473.svg";